module.exports = __webpack_public_path__ + "static/media/logo-banrisul.994c348d.png";